/* eslint-disable*/

import { Box, Typography } from '@material-ui/core'; // eslint-disable-line
import { useSelector } from 'react-redux';
import { currentchannel } from 'feactures/channel/channelSlice';
import CategoryShareTable from 'components/molecules/dashboard/CategoryShareTable';
import {
  selectAmazonCategoryShareGraph,
  selectRakutenCategoryShareGraph,
  selectYahooCategoryShareGraph
} from 'feactures/brand/categoryBrandShareSlice';

const BrandItemShareTable = () => {
  // 実際のデータはuseEffectで取得しreduxへ
  const categoryShareAmazonGraphData = useSelector(
    selectAmazonCategoryShareGraph
  );
  const categoryShareRakutenGraphData = useSelector(
    selectRakutenCategoryShareGraph
  );
  const categoryShareYahooGraphData = useSelector(
    selectYahooCategoryShareGraph
  );
  const channel = useSelector(currentchannel);

  let categoryGraphData = {
    graphdata: [],
    label: [],
    sales: [],
    percentage: []
  };

  if (channel == 1) {
    categoryGraphData = categoryShareAmazonGraphData.graphdata;
  } else if (channel == 2) {
    categoryGraphData = categoryShareRakutenGraphData.graphdata;
  } else if (channel == 3) {
    categoryGraphData = categoryShareYahooGraphData.graphdata;
  }

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
      {categoryGraphData.label.length === 0 ? (
        <Box
          minHeight="320px"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Typography fontSize={15}>表示できるデータがありません</Typography>
        </Box>
      ) : (
        <CategoryShareTable
          category={categoryGraphData.label}
          sales={categoryGraphData.sales}
          percentage={categoryGraphData.percentage}
          page="brandAnalysis"
        />
      )}
    </Box>
  );
};

export default BrandItemShareTable;
